import { Injectable } from '@angular/core'
import { Observable } from 'rxjs'
import { first, map } from 'rxjs/operators'

import { MembershipInvite } from 'app/models'

import { ApiService } from './api.service'
import { Mapper } from './mapper.service'
import { Store } from './store'

@Injectable({
  providedIn: 'root'
})
export class MembershipInviteService extends Store<MembershipInvite> {

  constructor(private api: ApiService) {
    super(new MembershipInvite({ }))
  }

  public findCurrent(id: string): void {
    const options: any = {
      include_sent_by_persona_name: true,
      include_tags: true
    }

    this.api.get('membership_invites/' + id, { params: options })
      .pipe(first())
      .subscribe(
        (data: any) => {
          const model = Mapper.as<MembershipInvite>(data.result, MembershipInvite)
          model['metadata'] = data.metadata
          this.subject.next(model)
        }
      )
  }

  public accept(
    invite: MembershipInvite,
    effectiveAt: string,
    minorToken?: string,
    membershipIds?: string[],
    memDefId?: string
  ): Observable<MembershipInvite> {
    const body: any = { requested_by: 'membership_ui' }
    if (effectiveAt) body.effective_at = effectiveAt
    if (memDefId) body.membership_definition_id = memDefId
    if (minorToken) {
      body.minor_token = minorToken
      body.redirect_params = 'purchase-for-minor'
    }
    if (membershipIds) body.membership_ids = membershipIds
    const url = `membership_invites/${invite.id}/accept`
    return this.api.post(url, body).pipe(first())
    .pipe(map(data => {
      const _invite = Mapper.as<MembershipInvite>(data.result, MembershipInvite)
      _invite.metadata = data.metadata
      return _invite
    }))
  }

  public dismiss(invite: MembershipInvite): void {
    this.api.post(`membership_invites/${invite.id}/dismiss`, { }).toPromise()
  }
}
